import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'polling-trigger',
  name: 'Polling Trigger',
  category: 'triggers',
  description:
    'Poll external systems for new records on a schedule. Connect any integration node to poll it automatically.',
  icon: 'Timer',
  color: 'purple',
  version: '2.0.0', // Major version bump for sub-node architecture

  group: ['trigger', 'schedule'],

  defaults: {
    name: 'Polling Trigger',
    color: '#a855f7',
  },

  subtitle: 'Connect a node to poll',

  // No credentials needed - connected sub-node handles its own credentials
  credentials: [],

  inputs: [],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main',
    },
  ],

  // Define anchor for sub-node connection
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'pollSource',
        label: 'Data Source',
        multiple: false,
        acceptTypes: ['*'], // Accept any node that can return records
      },
    ],
  },

  tags: ['polling', 'trigger', 'schedule', 'api', 'http', 'cron'],

  comingSoon: false,

  metadata: {
    documentation:
      'https://docs.evoworkflow.com/nodes/triggers/polling-trigger',
  },
};

export default definition;
